import * as React from 'react';
/**
 *
 * Original name: Rewind
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3792%3A503
 *
 */
export const RewindPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M36 21h-4v11h-7v4h11V21Z", fill: "currentColor" }),
    React.createElement("path", { d: "M32 8c-8.392 0-14.835 2.529-18.9 7.363a17.692 17.692 0 0 0-.652-4.091l-.521-1.822-3.846 1.1.519 1.821a13.82 13.82 0 0 1-.454 8.886l2.6 2.6a13.826 13.826 0 0 1 8.886-.455l1.822.521 1.1-3.846-1.821-.521a17.725 17.725 0 0 0-5.315-.65C18.642 14.323 24.207 12 32 12c13.271 0 20 6.729 20 20s-6.729 20-20 20c-6.4 0-11.321-1.565-14.637-4.651a13.832 13.832 0 0 1-.876-.892L13.51 49.13c.355.4.734.782 1.127 1.146C18.718 54.074 24.56 56 32 56c15.477 0 24-8.523 24-24S47.477 8 32 8Z", fill: "currentColor" })));
